import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import I18n from 'i18n-js';
import { Upload, Icon, Spin } from 'grab-ui';
import uploadIcon from 'public/images/upload-round.svg';
import { connect } from 'react-redux';
import scribeNewBulkUploadDuck from 'ducks/scribe-new-bulk-upload-duck';

import styles from './styles.less';

const UploadSpreadSheetModal = ({ disabled, uploadExcelFunc, dispatch }) => {
  const [uploading, setUploading] = useState(false);

  const beforeUpload = useCallback(
    file => {
      dispatch(
        scribeNewBulkUploadDuck.creators.scribeExpressNewBulkUploadStep1Upload(),
      );
      setUploading(true);
      uploadExcelFunc(file);
      setUploading(false);
      return false;
    },
    [setUploading, uploadExcelFunc],
  );

  return (
    <Upload.Dragger
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      beforeUpload={beforeUpload}
      showUploadList={false}
      className={styles.dragger}
      disabled={disabled}
    >
      {!uploading ? (
        <div
          className={styles.contentModal}
          role="button"
          tabIndex={-1}
          onKeyPress={null}
        >
          <div className={styles.subInfo}>
            <img
              src={uploadIcon}
              className={styles.fixedSize}
              alt=" Grab Upload Icon"
            />
            <p className={styles.greenText}>
              {I18n.t('v2.homepage.uploadOrder.modal.exploreXLS')}
            </p>
            <p className={styles.lightText}>
              {I18n.t('v2.homepage.uploadOrder.modal.dragFile')}
            </p>
          </div>
        </div>
      ) : (
        <Spin
          indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
        />
      )}
    </Upload.Dragger>
  );
};

UploadSpreadSheetModal.propTypes = {
  disabled: PropTypes.bool.isRequired,
  uploadExcelFunc: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect()(UploadSpreadSheetModal);
